/** Standard card shadow — single source of truth for all card surfaces. */
export const CARD_SHADOW = "shadow-md";

/** Background style names that produce a dark surface (light text on top). */
const DARK_BG_STYLES = new Set([
  "primary", "secondary", "tertiary", "brand", "primaryBg", "dark",
]);

/** Detect if a background style is dark (needs light-colored cards/content). */
export function isDarkBackground(bgStyle: string): boolean {
  return DARK_BG_STYLES.has(bgStyle);
}

/** Card style classes -- flat is background-aware. */
export function cardStyleClasses(style: string, bgStyle: string): string {
  switch (style) {
    case "flat":
      return isDarkBackground(bgStyle)
        ? "bg-white/10 rounded-lg p-6"
        : "bg-surface/50 rounded-lg p-6";
    case "outlined":
      return "bg-white rounded-lg p-6 border border-current/10";
    case "elevated":
    default:
      return `bg-white rounded-lg p-6 ${CARD_SHADOW}`;
  }
}
